import { createContext, useCallback, useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Timeline from "@/components/Timeline";
import Fabrics from "@/components/Fabrics";
import Process from "@/components/Process";
import Quality from "@/components/Quality";
import Gallery from "@/components/Gallery";
import Markets from "@/components/Markets";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SamplesModal from "@/components/SamplesModal";
import ChatWidget from "@/components/ChatWidget";
import Enquiries from "@/pages/Enquiries";

export const SampleModalContext = createContext(() => {});

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

function App() {
  const [samplesOpen, setSamplesOpen] = useState(false);
  const openSamples = useCallback(() => setSamplesOpen(true), []);
  const { pathname } = useLocation();
  const isSite = pathname === "/";

  useEffect(() => {
    if (!isSite) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [isSite]);

  return (
    <SampleModalContext.Provider value={openSamples}>
      <div className="App font-sans text-slate-700 antialiased">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Nav />
                <main>
                  <Hero />
                  <Marquee />
                  <About />
                  <Timeline />
                  <Fabrics />
                  <Process />
                  <Quality />
                  <Gallery />
                  <Markets />
                  <Contact />
                </main>
                <Footer />
                <ChatWidget />
              </>
            }
          />
          <Route path="/enquiries" element={<Enquiries />} />
        </Routes>
        <SamplesModal open={samplesOpen} onClose={() => setSamplesOpen(false)} />
        <Toaster position="top-center" />
      </div>
    </SampleModalContext.Provider>
  );
}

export default App;
